import axios from "axios";

export default class SimulationService { 
    
  getAllSimulation = async () => {
    try {
      const response = axios.get(`${process.env.REACT_APP_API_URL}/simulations`);
      return response;
    } catch (error) {
      throw new Error("Erreur  : " + error.message);
    }
  };
      getSimulation= async (id) => {
    try {
      const response = axios.get(`${process.env.REACT_APP_API_URL}/simulations/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors du get de la simulations : " + error.message
      );
    }
  };
 }